import { Modal } from "antd"
export { Modal }
